import { cn } from '../../lib/classNameHelpers';
import { Tooltip } from '../Tooltip/Tooltip';

type TwoRowCellProps = {
  primaryVal: React.ReactNode;
  secondaryVal: React.ReactNode;
  primaryClassName?: string;
  secondaryClassName?: string;
  primaryTooltip?: string;
  secondaryTooltip?: string;
  align?: 'left' | 'right';
  icon?: React.ReactNode;
};

export const TwoRowCell: React.FC<TwoRowCellProps> = ({
  primaryVal,
  secondaryVal,
  primaryClassName = '',
  secondaryClassName = 'text-contentSecondary',
  primaryTooltip,
  secondaryTooltip,
  align = 'left',
  icon,
}) => {
  const isRightAligned = align === 'right';

  return (
    <div
      className={cn('flex gap-2', {
        'justify-end': isRightAligned,
        'justify-start': !isRightAligned,
      })}
    >
      <div
        className={cn('flex flex-col', {
          'items-end': isRightAligned,
          'items-start': !isRightAligned,
        })}
      >
        {primaryTooltip ? (
          <Tooltip content={primaryTooltip} className="w-fit">
            <span className={cn('text-nowrap', primaryClassName)}>{primaryVal}</span>
          </Tooltip>
        ) : (
          <span className={cn('text-nowrap', primaryClassName)}>{primaryVal}</span>
        )}
        {secondaryTooltip ? (
          <Tooltip content={secondaryTooltip} className="w-fit">
            <span className={cn('text-nowrap text-3xs', secondaryClassName)}>{secondaryVal}</span>
          </Tooltip>
        ) : (
          <span className={cn('text-nowrap text-3xs', secondaryClassName)}>{secondaryVal}</span>
        )}
      </div>
      {icon && <div className="flex items-center">{icon}</div>}
    </div>
  );
};
